import React, { Component } from 'react'
import styled from 'styled-components'
import responsiveText from 'ui/styles/responsiveText'

import FlexibleLink from 'ui/components/generic/FlexibleLink'
import IconLargeCircledArrow from 'ui/components/generic/IconLargeCircledArrow'
import easing from 'ui/styles/easing'

export default class FocusBox extends Component {
  state = { hover: false }

  render() {
    const {
      box,
      count
    } = this.props

    const { hover } = this.state

    return(
      <Wrapper hover={hover}>
        <SmallCount>{count}</SmallCount>
        <Title>{box.title}</Title>
        <FlexibleLink
          href={box.link}
          onMouseEnter={() => this.setState({ hover: true })}
          onMouseLeave={() => this.setState({ hover: false })}
        >
          <Image image={box.image.sourceUrl}>
            <LargeCount hover={hover}>{count}</LargeCount>
          </Image>
        </FlexibleLink>
        <Text>{box.text}</Text>
        {box.link &&
          <FlexibleLink
            href={box.link}
            onMouseEnter={() => this.setState({ hover: true })}
            onMouseLeave={() => this.setState({ hover: false })}
            >
              <IconLargeCircledArrow hover={hover} />
          </FlexibleLink>
        }
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.tones.darker};
  border-color: ${props => props.hover ? props.theme.colors.primary : props.theme.colors.tones.lighter};
  transition: border-color 0.3s ${easing.easeOutCubic};
  padding-bottom: 25px;
`

const SmallCount = styled.span`
  color: ${props => props.theme.colors.primary};
  font-weight: ${props => props.theme.fontWeights.semiBold};
`

const Title = styled.h2`
  ${responsiveText('lg')}
`

const Image = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background: url(${props => props.image}) center / cover no-repeat;
  position: relative;
`

const LargeCount = styled.span`
  font-size: 80px;
  line-height: 80px;
  font-weight: ${props => props.theme.fontWeights.light};
  position: absolute;
  left: 25px;
  bottom: 30px;
  color: ${props => props.hover ? 'white' : props.theme.colors.secondaryDark};
  transition: color 0.3s ${easing.easeOutCubic};
`

const Text = styled.p`
  margin-top: 28px;
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/FocusGrid/FocusBox.js